import { useMemo } from 'react';
import { getFactRevenue, getFactRevenueBySelectedCurrency } from '@utils/currencyUtils/CurrencyUtils';
import { PagesConfig } from '@utils/pageConfig/PagesConfigContext';
import { ProductType } from '@pages/product-analyzer/Product';
import { Option } from '@utils/pageConfig/Types';

export const useFactRevenueBySelectedCurrency = (
  pagesConfig: PagesConfig,
  appliedCountries: Option[],
  effectiveProductType: ProductType,
) => {
  const factRevenueBySelectedCurrency = useMemo(() => {
    return pagesConfig.isMultiCountryFeatureFlagPA
      ? getFactRevenueBySelectedCurrency(pagesConfig, appliedCountries, effectiveProductType)
      : getFactRevenue(pagesConfig, appliedCountries, effectiveProductType);
  }, [pagesConfig, appliedCountries, effectiveProductType]);

  return factRevenueBySelectedCurrency;
};
